export interface ShiftTemplate {
  id: string;
  startTime: string; // Format: HHmm (e.g., '0600')
  endTime: string;   // Format: HHmm (e.g., '1800')
  unpaidBreak?: number; // in minutes
  scopeOfPractice: string;
  position?: string;
  schedules?: string[];
}
